// extracted by mini-css-extract-plugin
export default {"illustration":"styles_illustration__rd2ar","secondaryButton":"styles_secondaryButton__kN-of"};